<template>
        <el-row :gutter="20">
      <el-col :span="20" :offset="2">
        <el-card class="box-card flex justify-center">
          <img src="@/assets/tbt-logo.png" class="w-20">
           </el-card> 
      </el-col>
    </el-row>
</template>
